import { useInfiniteQuery, UseQueryOptions } from '@tanstack/react-query';
import { GetGroupOrderProps, useGroupOrdersRepository } from './rest';

export const useInfiniteGroupOrders = (
    props: GetGroupOrderProps,
    { enabled }: Pick<UseQueryOptions, 'enabled'> = {},
) => {
    const { getGroupOrders } = useGroupOrdersRepository();

    return useInfiniteQuery(['group-orders', props], ({ pageParam }) => getGroupOrders({ pageParam, ...props }), {
        getNextPageParam: (lastData) => (lastData.hasMorePages ? lastData.currentPage + 1 : undefined),
        keepPreviousData: true,
        enabled,
    });
};
